import initAlgoliaSearchPanel from '../vue/algolia-search-panel/index';

export default () => {
  (function (header) {
    'use strict';

    const dom = {};

    const cacheDom = () => {
      dom.header = document.querySelector('#site-header');
      dom.headerPlaceholder = document.querySelector('.header-placeholder');
      dom.navItem = document.querySelectorAll('.js-mega-menu');
      dom.navMItem = document.querySelectorAll('.js-mega-mobile-menu');
      dom.customer = document.querySelector('.js-customer');
      dom.searchIcon = document.querySelector('.js-searchIcon');
      dom.searchCloseIcon = document.querySelector('.js-searchCloseIcon');
      dom.cartIcon = document.querySelector('.js-cart-count');
      dom.wishlistIcon = document.querySelector('.header__wishlist-navigation-icon');
      dom.newArrivalData = [
        { parentName: 'Men', count: window.mensNewArrivals },
        { parentName: 'Women', count: window.womensNewArrivals },
        { parentName: 'Kids', count: window.kidsNewArrivals },
        { parentName: 'Gear', count: window.gearNewArrivals },
        { parentName: 'Bags & Gear', count: window.gearNewArrivals },
        { parentName: 'Bags &amp; Gear', count: window.gearNewArrivals },
        { parentName: 'Footwear', count: window.footwearArrivals },
      ];
    };

    const handleHeaderSticky = () => {
      const IO = new IntersectionObserver(ObserverEntry => {
        ObserverEntry.forEach(entry => {
          const { isIntersecting } = entry;
          dom.header.classList.toggle('header--sticky', !isIntersecting);
        });
      });
      IO.observe(dom.headerPlaceholder);
    };

    const handleNavHover = (item, newArrivalText, type) => {     
      const link = item.querySelector('.nav__menu-link');
 
      const activateNavItem = () => {
        item.classList.add('is--active');
        document.body.classList.add('overflow__hide');
        link.setAttribute('aria-expanded', 'true');
      };

      const deactivateNavItem = () => {
        item.classList.remove('is--active');
        document.body.classList.remove('overflow__hide');
        link.setAttribute('aria-expanded', 'false');
      };

      // Mouse events
      item.addEventListener('mouseover', activateNavItem);
      item.addEventListener('mouseleave', deactivateNavItem);

      // Keyboard navigation events
      item.addEventListener('focusin', activateNavItem);
      item.addEventListener('focusout', (e) => {
        // Only deactivate if focus moved outside the item
        if (!item.contains(e.relatedTarget)) {
          deactivateNavItem();
        }
      });

      newArrival(item, newArrivalText, type);
    };

    const handleCustomerHover = () => {
      const customerButton = dom.customer.querySelector('button[aria-label="Account button"]');
      const customerMenu = dom.customer.querySelector('#customer-menu');

      const activateCustomer = () => {
        dom.customer.classList.add('active');
        document.body.classList.add('overflow__hide');

        // Set ARIA attributes
        if (customerButton) {
          customerButton.setAttribute('aria-expanded', 'true');
        }
        if (customerMenu) {
          customerMenu.setAttribute('aria-hidden', 'false');
        }
      };

      const deactivateCustomer = () => {
        dom.customer.classList.remove('active');
        document.body.classList.remove('overflow__hide');

        // Set ARIA attributes
        if (customerButton) {
          customerButton.setAttribute('aria-expanded', 'false');
        }
        if (customerMenu) {
          customerMenu.setAttribute('aria-hidden', 'true');
        }
      };

      // Mouse events
      dom.customer.addEventListener('mouseover', activateCustomer);
      dom.customer.addEventListener('mouseleave', deactivateCustomer);

      // Keyboard navigation events
      dom.customer.addEventListener('focusin', activateCustomer);
      dom.customer.addEventListener('focusout', (e) => {
        // Only deactivate if focus moved outside the item
        if (!dom.customer.contains(e.relatedTarget)) {
          deactivateCustomer();
        }
      });
    };

    const handleSearchIconClick = () => {
      let searchPanelInitialized = false;

      dom.searchIcon.addEventListener('click', () => {
        if (!searchPanelInitialized) {
          initAlgoliaSearchPanel();
          searchPanelInitialized = true;
        }
        window.toggleAlgoliaSearch(true);
      });
    };

    const handleSearchCloseIconClick = () => {
      dom.searchCloseIcon.addEventListener('click', () => {
      });
    };

    const handleCartIconClick = () => {
      dom.cartIcon.addEventListener('click', () => {
        window.openCart({cartConfirmation:false});
      });
    };

    const newArrival = (item, query, type) => {
      const data = dom.newArrivalData.find(data => data.parentName === query);
      if (data && data.count) {
        [...item.querySelectorAll('a.nav__dropdown-submenu-title')]
        .filter(element => type === 'mobile' ? element.innerHTML.includes('New Arrivals') : element.innerText.includes('New Arrivals'))
        .forEach(element => {
          element.insertAdjacentHTML('beforeend', `<span class="nav__dropdown-submenu--newArrivalCount">${data.count}</span>`);
        });
      }
    };

    const handleWishlistIconClick = () => {
      dom.wishlistIcon.addEventListener('click', () => {
        window.location.pathname = '/pages/wishlist';
      });
    };

    const handleNavItemsSwap = async (isMobile = false) => {
      const wrapperClass = isMobile ? '.m__nav-item' : '.nav__menu-item';
      const titleClass = isMobile ? '.m__nav-item-title' : '.nav__menu-link';

      const mobileNavItems = document.querySelectorAll(wrapperClass);
      const variantId = 'f7f37754-6bce-4272-86e7-d6664b6ea753';
      const onVariant = window.shoplift && await window.shoplift.isHypothesisActive(variantId) || false;
    
      if (!onVariant) {
        return;
      }
    
      mobileNavItems.forEach((item, index) => {
        const link = item.querySelector(titleClass);
        if (link && link.textContent.trim().toLowerCase() === 'men') {
          const nextItem = mobileNavItems[index + 1];
          if (nextItem && nextItem.parentNode) {
            item.parentNode.insertBefore(nextItem, item); // swap Men with the next item
          }
        }
      });
    };
    

    const init = () => {
      handleNavItemsSwap();
      handleNavItemsSwap(true);
      
      cacheDom();
      handleHeaderSticky();

      dom.navItem.forEach(item => handleNavHover(item,item.children[0].innerText ,'desktop'));
      dom.navMItem.forEach(item => handleNavHover(item, item.children[0].children[0].children[0].innerHTML,'mobile'));

      handleCustomerHover();
      handleSearchIconClick();
      handleSearchCloseIconClick();
      handleCartIconClick();
      handleWishlistIconClick();
    };

    header.init = init;
  })((window.header = window.header || {}));
};
